import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "c-pager" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-full-left",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-full-left"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-left" })
], -1 /* HOISTED */)
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = {
  key: 2,
  class: "c-pager__separator"
}
const _hoisted_8 = ["onClick", "aria-label"]
const _hoisted_9 = { class: "sr-only" }
const _hoisted_10 = { class: "c-pager__number -current" }
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = ["onClick", "aria-label"]
const _hoisted_13 = { class: "sr-only" }
const _hoisted_14 = {
  key: 5,
  class: "c-pager__separator"
}
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { class: "sr-only" }
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-full-left",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-full-left"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-left" })
], -1 /* HOISTED */)
const _hoisted_19 = { class: "sr-only" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.pagerInfo.currentPage>1)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.goToPage($props.pagerInfo.currentPage -= 1)), ["prevent"])),
          href: "#",
          class: "c-pager__prev",
          "aria-label": $options.t('Aller à la page précédente')
        }, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString($options.t("Aller à la page précédente")), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    ($props.pagerInfo.currentPage>3)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.goToPage($props.pagerInfo.currentPage = 1)), ["prevent"])),
          class: "c-pager__number",
          href: "#",
          "aria-label": $options.t('Aller à la page')+' : 1'
        }, [
          _createTextVNode(_toDisplayString(1) + " "),
          _createElementVNode("span", _hoisted_6, _toDisplayString($options.t("Aller à la page")) + " : 1 ", 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_5))
      : _createCommentVNode("v-if", true),
    ($props.pagerInfo.currentPage>4)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "..."))
      : _createCommentVNode("v-if", true),
    ($options.getPrevPages(2))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList($options.getPrevPages(2), (number) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: _withModifiers($event => ($options.goToPage($props.pagerInfo.currentPage = number)), ["prevent"]),
            class: "c-pager__number",
            href: "#",
            "aria-label": $options.t("Aller à la page")+" : "+ number
          }, [
            _createTextVNode(_toDisplayString(number) + " ", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_9, _toDisplayString($options.t("Aller à la page")) + " : " + _toDisplayString(number), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_8))
        }), 256 /* UNKEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", _hoisted_10, [
      _createTextVNode(_toDisplayString($props.pagerInfo.currentPage) + " ", 1 /* TEXT */),
      _createElementVNode("span", _hoisted_11, _toDisplayString($options.t("Vous êtes actuellement sur cette page")), 1 /* TEXT */)
    ]),
    ($options.getNextPages(2))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList($options.getNextPages(2), (number) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: _withModifiers($event => ($options.goToPage($props.pagerInfo.currentPage = number)), ["prevent"]),
            class: "c-pager__number",
            href: "#",
            "aria-label": $options.t("Aller à la page")+" : "+ number
          }, [
            _createTextVNode(_toDisplayString(number) + " ", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_13, _toDisplayString($options.t("Aller à la page")) + " : " + _toDisplayString(number), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_12))
        }), 256 /* UNKEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($props.pagerInfo.currentPage < $props.pagerInfo.totalPages-3)
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "..."))
      : _createCommentVNode("v-if", true),
    ($props.pagerInfo.currentPage < $props.pagerInfo.totalPages-2)
      ? (_openBlock(), _createElementBlock("a", {
          key: 6,
          onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.goToPage($props.pagerInfo.currentPage = $props.pagerInfo.totalPages)), ["prevent"])),
          class: "c-pager__number",
          href: "#",
          "aria-label": $options.t("Aller à la page")+" : "+ $props.pagerInfo.totalPages
        }, [
          _createTextVNode(_toDisplayString($props.pagerInfo.totalPages) + " ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_16, _toDisplayString($options.t("Aller à la page")) + " : " + _toDisplayString($props.pagerInfo.totalPages), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_15))
      : _createCommentVNode("v-if", true),
    ($props.pagerInfo.currentPage<$props.pagerInfo.totalPages)
      ? (_openBlock(), _createElementBlock("a", {
          key: 7,
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($options.goToPage($props.pagerInfo.currentPage += 1)), ["prevent"])),
          href: "#",
          class: "c-pager__next",
          "aria-label": $options.t('Aller à la page suivante')
        }, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString($options.t("Aller à la page suivante")), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_17))
      : _createCommentVNode("v-if", true)
  ]))
}